import { EditPersonRequest } from "@shared/dtos/requests/personRequests.dto"
import {
  AttestBsnCheckRequest,
  AttestIdentificationVerificationRequest,
} from "@shared/zod/schemas/requests/personRequests"
import { PersonChangelogResponse } from "@shared/zod/schemas/responses/personChangelog"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const edit = (id: string, data: EditPersonRequest): Promise<void> => {
  return axiosAuth({
    url: `/persons/${id}`,
    method: "patch",
    data: data,
  }).then(() => undefined)
}

/**
 * Per-field history of a person's personal details, fields in form order and
 * entries oldest first. Both the registration and the patient screen read it
 * from here — they resolve a person from different ids, but both know the
 * person id.
 */
export const changelog = (id: string): Promise<PersonChangelogResponse> => {
  return axiosAuth({
    url: `/persons/${id}/changelog`,
    method: "get",
  }).then((resp) => resp.data)
}

export const attestIdentificationVerification = (
  id: string,
  data: AttestIdentificationVerificationRequest
): Promise<void> => {
  return axiosAuth({
    url: `/persons/${id}/identificationVerification`,
    method: "post",
    data: data,
  }).then(() => undefined)
}

export const attestBsnCheck = (id: string, data: AttestBsnCheckRequest): Promise<void> => {
  return axiosAuth({
    url: `/persons/${id}/bsnCheck`,
    method: "post",
    data: data,
  }).then(() => undefined)
}
